import React, { useEffect, useState } from "react";
import "./style.scss";
import PaginationComponent from "../../../general/PaginationComponent";
import SubscribeKnowledgeStack from "../SubscribeKnowledgeStack";
import { getBehaviouralBlogs } from "../actions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formDataGenerator } from "../../../../../utils/common";
import { Helmet } from "react-helmet";

const BehaviouralBlogs = (props) => {

  const {getBehaviouralBlogs, behaviouralBlogsData, location: { pathname },} = props;

  const [searchValue, setsearchValue] = useState("");
  const [blogBanner, setBlogBanner] = useState([]);
  const [blogData, setBlogData] = useState('');
  const [limit, setLimit] = useState(8);
  const [offset, setOffset] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [data, setData] = useState([]);
  const [metaData, setMetaData] = useState();

  const getPaginatedData = (page) => {
    loadData(page);
  };

  const loadData = (page) => {
    const offsetValue = limit * page;
    let params = {
      search: searchValue ? searchValue : "",
      limit: limit,
      offset: limit * (page - 1),
    };
    getBehaviouralBlogs(formDataGenerator(params));
    let unit = window.innerHeight / 100;
    window.scrollTo({ top: 40 * unit });
  };

  useEffect(() => {
    let params = {
      search: searchValue ? searchValue : "",
      limit: limit,
      offset: offset,
    };
    getBehaviouralBlogs(formDataGenerator(params));
  }, [searchValue]);

  useEffect(() => {
    if (behaviouralBlogsData && 
      behaviouralBlogsData.blockDetail && behaviouralBlogsData.blockDetail[0]) {
      setBlogBanner(behaviouralBlogsData.blockDetail[0]);
    }

    if (behaviouralBlogsData && behaviouralBlogsData.items) {
      setBlogData(behaviouralBlogsData.items);
      setTotalRecords(behaviouralBlogsData.count ? behaviouralBlogsData.count : 0);
    }

    // if (behaviouralBlogsData && behaviouralBlogsData.count) {
    //   setTotalRecords(behaviouralBlogsData.count);
    // }

    if (behaviouralBlogsData && behaviouralBlogsData.meta) {
      setMetaData(behaviouralBlogsData.meta);
    }
  }, [behaviouralBlogsData]);

  const handleInputsearch = (e) => {
    setsearchValue(e.target.value);
    setActivePage(1);
  }

  const typedata = "Behavioural Blogs";
  const articledata = "";
  
  return (
    <>
      <div className="wrapper">
      {
        metaData ? (
          <Helmet>
            <title>{metaData && metaData.title ? metaData.title : ""}</title>
            <meta name="description"
              content={
                metaData && metaData.description ? metaData.description : ""
              }
            />
            <meta name="keywords"
              content={
                metaData && metaData.keywords ? metaData.keywords : ""
              }
            />
            <meta property="og:title"
              content={
                metaData && metaData.og_title ? metaData.og_title : ""
              }
            />
            <meta property="og:description"
              content={
                metaData && metaData.og_description ? metaData.og_description : ""
              }
            />
            <meta property="og:image"
              content={
                metaData && metaData.og_image ? metaData.og_image : ""
              }
            />
            <meta property="og:url"
              content={
                metaData && metaData.og_url ? metaData.og_url : ""
              }
            />
          </Helmet>
        ) : ("")
      }
        <section className="aboutHead">
          <div className="container">
            <div className="d-flex dropdowncls">
              <div className="me-auto">
                <div>
                  <h1>
                    <span>Behavioural</span> Blogs
                  </h1>
                </div>
              </div>
              <nav
                aria-label="breadcrumb"
                className="align-self-center breadCrumbCust d-md-inlin"
              >
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a href="/knowledge-stack">Knowledge Stack</a>
                  </li>
                  <li
                    className="breadcrumb-item active breadcolor"
                    aria-current="page"
                  >
                    Behavioural Blogs
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </section>
        <section>
          <div className="bannerblog mb-4">
            <img
              src={blogBanner && 
                blogBanner.bannerUrl && blogBanner.bannerUrl.url ? 
                blogBanner.bannerUrl.url : ""}
              alt={blogBanner && 
                blogBanner.bannerUrl && blogBanner.bannerUrl.alt ? 
                blogBanner.bannerUrl.alt : ""}
              className="w-100"
            />
            <div>
              <div className="row bannerdiv">
                <div className="col-md-10">
                  <div className="mt-3 bluebgtext">
                    {
                      blogBanner && 
                      blogBanner.body ? 
                        <div 
                        dangerouslySetInnerHTML={{
                          __html: blogBanner.body,
                        }}
                        /> : ""
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container my-5 blogss">
            <div className="row my-4">
              <div className={searchValue ? "col-md-5 d-flex" : "col-md-4 d-flex"}>
                <div className="input-group mb-3 ipgroup">
                  <span
                    className="input-group-text serchcolor"
                    id="inputGroup-sizing-default"
                  >
                    <img src="/images/New/grey-search.svg" alt="search" />
                  </span>
                  <input
                    type="text"
                    className="form-control searchb ps-0 py-2"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    placeholder="Search..."
                    onChange={handleInputsearch}
                    value={searchValue}
                  />
                </div>
                {
                  searchValue ?
                  <button 
                    className="btn resetbtn"
                    onClick={handleInputsearch}
                  >Reset</button>
                  : ""
                }
                
              </div>
            </div>

            <div className="row">
              {
                blogData && blogData.length > 0 ?
                (blogData.map((item, index) => (
                  <div className="col-md-3 mb-3">
                    <div className="card">
                      <a href={`/knowledge-stack/behavioural-blogs/${item.linkUrl}`}>
                        <img
                          src={item.imageURL && item.imageURL.url ? item.imageURL.url : ""}
                          className="card-img-top w-100"
                          alt={item.imageURL && item.imageURL.alt ? item.imageURL.alt : ""}
                        />
                      </a>
                      <div className="card-body px-0">
                        <a href={`/knowledge-stack/behavioural-blogs/${item.linkUrl}`}>
                          <h5 className="card-title">{item.title ? item.title : ""}</h5>
                        </a>
                        <p className="card-text">{item.blockDetail ? item.blockDetail : ""}</p>
                        <div className="timestamp">
                          <p>{item.publishedDate ? item.publishedDate: ''}</p>
                          <p>{item.time ? item.time :""}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )))
                : (
                  <div className='nodata'>
                    <p>No content found.</p>
                  </div>
                )
              }
            </div>

            {
              totalRecords > 8 &&
              <div className="row">
                <div className="col-md-12">
                  <div className="paginate d-flex justify-content-center">
                    <PaginationComponent
                      totalRecords={totalRecords}
                      activePage={activePage}
                      setActivePage={setActivePage}
                      data={data}
                      limit={limit}
                      getPaginatedData={getPaginatedData}
                      itemsCountPerPage={limit}
                    />
                  </div>
                </div>
              </div>
            }

            <SubscribeKnowledgeStack type={typedata} article={articledata}/>
          </div>
        </section>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  behaviouralBlogsData: state.KnowledgeStack.BehaviouralListData,
});
  
const mapDispatchToProps = (dispatch) => ({
  getBehaviouralBlogs: bindActionCreators(getBehaviouralBlogs, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(BehaviouralBlogs);
